import { BuilderConfig } from '@/types/Builder';
import B2BHero, { Props } from './b2b-hero';
import { Button } from '@builder.io/react';

export const B2BHeroBuilderConfig = {
    name: 'B2B Hero',
    inputs: [
        {
            name: 'subTitle',
            type: 'richText',
        },
        {
            name: 'title',
            type: 'richText',
        },
        {
            name: 'useLargeTitle',
            type: 'boolean',
        },
        {
            name: 'description',
            type: 'richText',
        },
        {
            name: 'categories',
            type: 'list',
            subFields: [
                {
                    name: 'category',
                    type: 'reference',
                    model: 'category',
                    includeRefs: true,
                },
            ],
        },
        { name: 'fontSizeTitle', type: '' },
        {
            name: 'titleMaxWidth',
            type: 'number',
        },
        {
            name: 'descriptionMaxWidth',
            type: 'number',
        },
        {
            name: 'backgroundImage',
            type: 'object',
            subFields: [
                {
                    name: 'desktop',
                    type: 'file',
                },
                {
                    name: 'mobile',
                    type: 'file',
                },
            ],
        },
        {
            name: 'background',
            type: 'color',
        },
        {
            name: 'textColor',
            type: 'color',
        },
        {
            name: 'button',
            type: 'object',
            subFields: [
                {
                    name: 'name',
                    type: 'string',
                },
                {
                    name: 'url',
                    type: 'string',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<Props> = {
    component: B2BHero,
    config: B2BHeroBuilderConfig,
};

export default builderConfig;
